export function setUserId(userId: string) {
    localStorage.setItem("userId", userId);   
}

export function getUserId(): string {
    const userId = localStorage.getItem("userId");    
    return userId || "";
}
